"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_icons_1 = __importDefault(require("tfs.css-icons"));
exports.default = {
    icon: {
        position: 'relative',
        display: 'inline-block',
        cursor: function (prop) { return prop.onClick && 'pointer'; },
        '&::before': {
            content: function (props) { return tfs_css_icons_1.default(props.name); },
            fontFamily: 'transavicon',
            fontWeight: 'normal',
            verticalAlign: 'middle',
            lineHeight: 1,
            transformOrigin: 'left center',
        },
    },
};
//# sourceMappingURL=Icon.styles.js.map